export default __webpack_public_path__ + "static/avatar-cd07764837ae1ed3b0ba2b6fd21d7a7a.jpg";